import axios from 'axios'
import { ApiConfig } from '../../../config/api'
import { utcFinalDate, utcIntialDate } from '../../../utils/dateHelper'
import { Filter } from '../../../components/_WMS/FilterComponent'
import { eTypeWorkOrder } from '../../../enums/eTypeWorkOrder'

export const getWorkOrderOutbounds = (
  filters?: Filter[],
  page = 0,
  pageSize = 5,
  orderBy?: { field: string; direction: string }
) => {
  const url = new URL(`${ApiConfig.WorkOrderOutboundApi}`)

  url.searchParams.set('pageIndex', page.toString())

  url.searchParams.set('pageSize', pageSize.toString())

  url.searchParams.append('typeWorkOrderId', eTypeWorkOrder.Outbound.toString())
  url.searchParams.append('typeWorkOrderId', eTypeWorkOrder.PreSale.toString())

  if (filters) {
    filters.forEach((element) => {
      if (
        element.key === 'initialDeliveryDate' ||
        element.key === 'initialCreatedDate'
      ) {
        url.searchParams.set(element.key, utcIntialDate(element.value))
      } else if (
        element.key === 'finalCreatedDate' ||
        element.key === 'finalDeliveryDate'
      ) {
        url.searchParams.set(element.key, utcFinalDate(element.value))
      } else if (element.key === 'workOrderTag') {
        if (element.value.toString() === '')
          url.searchParams.set('IncludeWithoutTag', 'true')
        else url.searchParams.set(element.key, element.value.toString())
      } else {
        url.searchParams.append(element.key, element.value.toString())
      }
    })
  }

  if (orderBy) {
    url.searchParams.set(
      'sorters',
      JSON.stringify({ datafield: orderBy.field, sortOrder: orderBy.direction })
    )
  }

  return axios.get(url.toString())
}

export const updateWorkOrderTopPriority = (
  workOrderId: number,
  page: number,
  pageSize: number,
  filters?: Filter[]
) => {
  const url = new URL(
    `${ApiConfig.WorkOrderOutboundApi}/UpdatePriorityTop?typeWorkOrderId=${eTypeWorkOrder.Outbound.toString()}&updateWorkOrderId=${workOrderId}&pageIndex=${page}&pageSize=${pageSize}`
  )

  if (filters) {
    filters.forEach((element) => {
      if (
        element.key === 'initialDeliveryDate' ||
        element.key === 'initialCreatedDate'
      ) {
        url.searchParams.set(element.key, utcIntialDate(element.value))
      } else if (
        element.key === 'finalCreatedDate' ||
        element.key === 'finalDeliveryDate'
      ) {
        url.searchParams.set(element.key, utcFinalDate(element.value))
      } else if (element.key === 'workOrderTag') {
        if (element.value.toString() === '')
          url.searchParams.set('IncludeWithoutTag', 'true')
        else url.searchParams.set(element.key, element.value.toString())
      } else {
        url.searchParams.append(element.key, element.value.toString())
      }
    })
  }

  return axios.put(url.toString())
}
export const updateWorkOrderPriorityUp = (
  workOrderId: number,
  page: number,
  pageSize: number,
  filters?: Filter[]
) => {
  const url = new URL(
    `${ApiConfig.WorkOrderOutboundApi}/UpdatePriorityUp?typeWorkOrderId=${eTypeWorkOrder.Outbound.toString()}&updateWorkOrderId=${workOrderId}&pageIndex=${page}&pageSize=${pageSize}`
  )

  if (filters) {
    filters.forEach((element) => {
      if (
        element.key === 'initialDeliveryDate' ||
        element.key === 'initialCreatedDate'
      ) {
        url.searchParams.set(element.key, utcIntialDate(element.value))
      } else if (
        element.key === 'finalCreatedDate' ||
        element.key === 'finalDeliveryDate'
      ) {
        url.searchParams.set(element.key, utcFinalDate(element.value))
      } else if (element.key === 'workOrderTag') {
        if (element.value.toString() === '')
          url.searchParams.set('IncludeWithoutTag', 'true')
        else url.searchParams.set(element.key, element.value.toString())
      } else {
        url.searchParams.append(element.key, element.value.toString())
      }
    })
  }

  return axios.put(url.toString())
}
export const updateWorkOrderPriorityDown = (
  workOrderId: number,
  page: number,
  pageSize: number,
  filters?: Filter[]
) => {
  const url = new URL(
    `${ApiConfig.WorkOrderOutboundApi}/UpdatePriorityDown?typeWorkOrderId=${eTypeWorkOrder.Outbound.toString()}&updateWorkOrderId=${workOrderId}&pageIndex=${page}&pageSize=${pageSize}`
  )

  if (filters) {
    filters.forEach((element) => {
      if (
        element.key === 'initialDeliveryDate' ||
        element.key === 'initialCreatedDate'
      ) {
        url.searchParams.set(element.key, utcIntialDate(element.value))
      } else if (
        element.key === 'finalCreatedDate' ||
        element.key === 'finalDeliveryDate'
      ) {
        url.searchParams.set(element.key, utcFinalDate(element.value))
      } else if (element.key === 'workOrderTag') {
        if (element.value.toString() === '')
          url.searchParams.set('IncludeWithoutTag', 'true')
        else url.searchParams.set(element.key, element.value.toString())
      } else {
        url.searchParams.append(element.key, element.value.toString())
      }
    })
  }

  return axios.put(url.toString())
}
